import { bboxPolygon, booleanPointInPolygon, difference, point } from "@turf/turf";
import { Feature, GeometryObject, MultiPolygon, Polygon } from "geojson";
import { LatLng, LatLngBounds, LatLngLiteral } from "leaflet";

export class CityPolygonModel {

    private _geometry: Polygon | MultiPolygon;
    private _boundingbox: LatLngBounds;
    private _center: LatLng;

    constructor(
        private L: any,
        geometry: GeometryObject,
    ){
        if (geometry.type != "Polygon" && geometry.type != "MultiPolygon"){
             throw "Invalid GeometryObject";
        }

        this._geometry = geometry;

        var feature = this.L.geoJSON(geometry);
        this._boundingbox = feature.getBounds();
        this._center = this._boundingbox.getCenter();
    }

    public get center(): LatLng {
        return this._center;
    }

    public getBounds(): LatLngBounds {
        return this._boundingbox;
    }

    public getCenter(): LatLng {
        return this._center;
    }

    public getGeometry(): Polygon | MultiPolygon {
        return this._geometry;
    }

    public getFeature(): Feature<Polygon | MultiPolygon> {
        return {
            type: 'Feature',
            geometry: this._geometry,
            properties: {}
        };
    }

    public getInvertedFeature(): Feature<Polygon | MultiPolygon> | null {
        const world = bboxPolygon([-180, -90, 180, 90]);
        const inner = this.getFeature();

        return difference({
            type: 'FeatureCollection',
            features: [world, inner]
        });
    }

    public checkPointInside(lat: number, lng: number): boolean {
        return booleanPointInPolygon(point([lng, lat]), this.getGeometry());
    }

    public containsPoint(point: LatLngLiteral): boolean {
        return this.checkPointInside(point.lat, point.lng);
    }

    public getLeafletLayer(inverted = false): L.GeoJSON {
        const feature = inverted ? this.getInvertedFeature() : this.getFeature();

        return this.L.geoJSON(feature, {
            style: { stroke: false, fillOpacity: 0.2 },
        });
    }
}
